import React, { FC, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import {
    clearStatus,
    selectClientUnsubscribeStatus,
    postClientUnsubscribeAsync
} from "../../features/client/clientUnsubscribeSlice";

import styled from "styled-components";

import Alert from "react-bootstrap/Alert";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from "react-bootstrap/Spinner";

type ClientUnsubscribeProps = {};

export const ClientUnsubscribe: FC<ClientUnsubscribeProps> = () => {

    const dispatch = useAppDispatch();

    const status = useAppSelector(selectClientUnsubscribeStatus);

    const queryParams = new URLSearchParams(window.location.search);

    const emailParam = queryParams.get("email");

    const errorAlertMessage = "I am very sorry. There seems to have been an error."
    const successAlertMessage = "You have successfully unsubscribed."


    // Email field hooks
    const [email, setEmail] = useState(emailParam);
    const emailValue = String(email) || "";

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	}

    const submitHandler = (event: React.FormEvent) => {
        event.preventDefault();

        dispatch(postClientUnsubscribeAsync({email: emailValue}));
    }

    return (
        <>
            <Container>
                {status === "failed" &&
                    <Alert variant="danger" onClose={ () => dispatch(clearStatus()) } dismissible>
                        {errorAlertMessage}
                    </Alert>
                }
                {status === "success" &&
                    <Alert variant="success" onClose={ () => dispatch(clearStatus()) } dismissible>
                        {successAlertMessage}
                    </Alert>
                }
                <ContentSection className="w-100 m-auto">
                    <Form onSubmit={submitHandler}>
                        <h2 className="mb-3 fw-bold">Unsubscribe</h2>
                        <h5 className="mb-3 fw-normal">We're sorry to see you go, please confirm your email to unsubscribe from the list.</h5>

                        <Form.Group className="mb-4" controlId="formBasicEmail">
                            <Form.Control required type="email" placeholder="Please enter your email" value={email || ''} onChange={ handleEmailChange } />
                            <Form.Text className="text-muted">
                                Please confirm your email
                            </Form.Text>
                        </Form.Group>

                        <Button variant="primary" type="submit" disabled={ status == 'loading' ? true : false }>
                            { status == 'loading' &&
                                <div>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="visually-hidden">Loading...</span> 
                                </div>
                            }
                            {status == 'loading' ? "" : "Submit"}
                        </Button>

                        {/* <a className="mt-3 link-secondary d-block" href="#">Opt out of all email comminications</a> */}
                    </Form>
                </ContentSection>
            </Container>
        </>
    );
}

const ContentSection = styled.div`
    max-width: 500px;
    padding: 15px;
`